import React from 'react';
import { useNavigate } from 'react-router-dom';
import SelectBookingCategoryPage from './SelectBookingCategoryPage';

const SelectBookingCategoryPageWrapper = () => {
  const navigate = useNavigate();
  
  return <SelectBookingCategoryPage navigate={navigate} />;
};

export default SelectBookingCategoryPageWrapper;
